module.exports = __webpack_public_path__ + "static/media/subscription.54d61ee1.png";